import http from 'utils/http';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { BusinessProfileResponse } from './types';
import { getBusinessInteractionsLogsUrl, getBusinessProfileUrl, getBusinessesUrl } from './apiUrls';
import { InteractionLogResponse } from './agent/callLogs/types';

export function getBusinesses(
  params?: Record<string, any>
): Promise<{ data: BusinessProfileResponse[]; meta: MetaApiResponse }> {
  return http.get(getBusinessesUrl(), params);
}

export function getBusinessProfile(id: number, params?: Record<string, any>): Promise<BusinessProfileResponse> {
  return http.get(getBusinessProfileUrl(id), params);
}

export function updateBusinessProfile(id: number, payload: any): Promise<BusinessProfileResponse> {
  return http.patch(getBusinessProfileUrl(id), payload);
}

export function getBusinessInteractionsLogs(
  params?: Record<string, any>
): Promise<{ data: InteractionLogResponse[]; meta: MetaApiResponse }> {
  return http.get(getBusinessInteractionsLogsUrl(), params);
}
